import CircleIcon from '@mui/icons-material/Circle';
import { Box, Typography } from '@mui/material';
import { LegendProps } from 'recharts';

export const StatisticsLegend = (props: LegendProps) => {
  const { payload = [] } = props;

  if (!payload?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        mt: 2,
        gap: 3,
      }}
    >
      {payload.map((entry, index) => (
        <Box
          key={index}
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}
        >
          <CircleIcon
            sx={{
              color: entry.color,
              fontSize: 11,
            }}
          />
          <Typography sx={{ fontSize: 12 }}>{entry.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};
